export const getSafePageCount = (totalItems: number, rowsPerPage: number) => {
    if (!Number.isFinite(totalItems) || !Number.isFinite(rowsPerPage) || rowsPerPage <= 0) {
        return 1;
    }

    return Math.max(1, Math.ceil(Math.max(0, totalItems) / rowsPerPage));
};

export const clampPage = (page: number, pageCount: number) => {
    if (!Number.isFinite(page)) {
        return 1;
    }

    return Math.min(Math.max(Math.floor(page), 1), pageCount);
};
